<template>
    <div class="watchlists">
        <AonContainer add-page-padding class="bg-moat-900">
            <AonRow>
                <AonCol class="grid-cols-12 pt-xxl pb-xxxl">
                    <div class="header-holder display-flex w-100 justify-between items-center">
                        <div class="header-copy-holder">
                            <h4 class="text-stone-0">
                                {{ $t('watchlists.title') }}
                            </h4>
                            <p class="text-stone-0">
                                Create a collection of companies to save and use as a filter in
                                competitive benchmarking
                            </p>
                        </div>
                        <AonButton
                            label="Add Watchlist"
                            @clicked="datasetStore.toggleShowOnlyCreateWatchLists()"
                        />
                    </div>
                </AonCol>
            </AonRow>
        </AonContainer>
        <AonContainer add-page-padding class="mt-n4">
            <AonRow>
                <AonCol class="grid-cols-12">
                    <WatchlistList :key="updater" />
                </AonCol>
            </AonRow>
        </AonContainer>
    </div>
</template>

<script setup>
import { useDatasetStore } from '@/stores'
const datasetStore = useDatasetStore()
import WatchlistList from '@/components/Watchlists/WatchlistList'
import { ref, inject } from 'vue'
const eventBus = inject('eventBus')

const updater = ref(0)

eventBus.on('updateWatchlistPage', async () => {
    updater.value++
})
</script>

<style lang="scss" scoped>
.watchlists {
    min-height: 100vh;
    height: 100%;
}
</style>
